export const generateNamePrefix = (prefix: string) => {
  return (string: TemplateStringsArray, ...params: any[]): string => {
    return [prefix, ...string.map((s, i) => `${s}${params[i] ?? ''}`)].join('');
  };
};

// 投放渠道1级
export const getChannelName = (uuid: string) => {
  let name = '';
  switch (uuid) {
    case '685a0980-f8e9-4b81-9cfb-60a465914fa2':
      name = '自有渠道';
      break;
    case '634a702d-8049-4ea4-ab0e-513d20d27748':
      name = '广告投放';
      break;
    case '5d5bd70a-9117-48f6-b324-499a24117f91':
      name = '文章合作';
      break;
    case '02f0a1a0-bcaf-4db8-afd9-b0f9f1173c89':
      name = '原创内容';
      break;
    case '4874ce62-302f-49be-bd81-3377fc5d1a46':
      name = '供稿合作';
      break;
    case 'c5940051-1f39-411a-b670-8d577eab4386':
      name = '资源位采买';
      break;
    case 'b6bc3c04-7261-49c1-81b1-3999f29d2810':
      name = '佣金合作';
      break;
    case 'b78bb339-f408-4073-a7cc-b757099fb28b':
      name = '商务BD';
      break;
    default:
      name = '';
      break;
  }
  return name;
};

// 判断是否在微信环境
export const isWechatEnvironment = () => {
  const ua = window.navigator.userAgent;
  const data = ua.match(/MicroMessenger/i) || [];
  // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if (data[0] === 'MicroMessenger') {
    return true;
  }
  return false;
};

// 当前设备信息 是否是移动端
export const isMobile = () => {
  const ua = window.navigator.userAgent;
  const data = ua.match(/Android|webOS|iPhone|iPod|iPod|BlackBerry/i) || [];
  if (data[0]) {
    return true;
  }
  return false;
};

// 判断创建线索返回信息 是否已提交 重复进线
export const messageIsRepeat = (msg: string) => {
  if (msg) {
    return /已提交|已存在|exists|submit|submitted/.test(msg);
  }
  return false;
};
